import { createBrowserRouter } from 'react-router-dom';
import AdminPanel from '../pages/AdminPanel';
import EmployeeLogin from '../pages/EmployeeLogin';
import Dashboard from '../pages/Dashboard';
import CreateServices from '../pages/CreateServices';
import AllServices from '../pages/AllServices';
const router = createBrowserRouter([
    {
        path: "/employee-login", element: <EmployeeLogin />,
    },
    {
        path: "/",
        element: <AdminPanel />,
        children: [
            { path: "/", element: <Dashboard/>},
            { path: "/create-services", element: <CreateServices/> },
            { path: "/all-services", element: <AllServices/> },
        ]
    }
]);

export default router;
